import { render, staticRenderFns } from "./WorkFlowEditTitleComponent.vue?vue&type=template&id=327a1037&scoped=true&"
import script from "./WorkFlowEditTitleComponent.vue?vue&type=script&lang=ts&"
export * from "./WorkFlowEditTitleComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WorkFlowEditTitleComponent.vue?vue&type=style&index=0&id=327a1037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a1037",
  null
  
)

export default component.exports